import { Injectable } from '@angular/core'
import { Actions, Effect, ofType } from '@ngrx/effects'
import { Action, Store } from '@ngrx/store'
import { BaseModel } from 'app/core/models'
import { VacationRequestService } from 'app/core/services'
import { State } from 'app/core/store/states'
import { Observable } from 'rxjs/Observable'
import { of } from 'rxjs/observable/of'
import { mergeMap } from 'rxjs/operators'

import * as RequestStatusTypeActions from '../../actions/enums/request-status-type.actions'

@Injectable()
export class RequestStatusTypeEffects {

    constructor(
        private actions$: Actions,
        private store: Store<State>,
        private vacationRequestService: VacationRequestService
    ) { }

    @Effect()
    GetAll$: Observable<Action> = this.actions$.pipe(
        ofType<RequestStatusTypeActions.GetAll>(RequestStatusTypeActions.GET_ALL),
        mergeMap((action) => {
            return this.vacationRequestService.getAllStatus().map(
                (requestStatusTypes: BaseModel[]) => {
                    return new RequestStatusTypeActions.GetAllSuccess(requestStatusTypes)
                }, _ => of(new RequestStatusTypeActions.GetAllError()))
        })
    )
}